import { RFIResponseDisciplines } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Response Discipline'
const page = RFIResponseDisciplines

const responseDiscipline = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: 'FC524F86-718B-4C5C-903F-D2A09F3155F8',
  view: '1CC64E6F-3965-4735-80D9-04E75DEB5FDF',
  edit: '158ECFD2-388E-4530-9222-5BBAE962176F',
  removeRestore: '9EB26418-0910-455F-A52C-8C10172F0540',
})

export const CreateRFIResponseDiscipline = responseDiscipline.Create
export const ViewRFIResponseDiscipline = responseDiscipline.View
export const EditRFIResponseDiscipline = responseDiscipline.Edit
export const RemoveRestoreRFIResponseDiscipline =
  responseDiscipline.RemoveRestore

export type RFIResponseDisciplinePermission =
  | typeof CreateRFIResponseDiscipline
  | typeof ViewRFIResponseDiscipline
  | typeof EditRFIResponseDiscipline
  | typeof RemoveRestoreRFIResponseDiscipline
